import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.7rem',
    },

    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },

    '*::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      outline: `1px solid ${theme.palette.secondary.main}`,
    },
  },

  accessoryTable: {
    overflowY: 'scroll',
    width: '500px',
    maxHeight: '100%',

    table: {
      '& td, & th': {
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        textAlign: 'center',
        padding: theme.spacing(1),
      },
    },
  },

  nestedProduct: {
    transition: '0.2s',

    '&:hover': {
      background: theme.palette.secondary.main,
      color: theme.palette.white.main,
      cursor: 'pointer',
      transition: '0.2s',
    },
  },

  accessoryNotification: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
    fontSize: '2rem',
    color: theme.palette.white.main,
    fontWeight: '600',
    background: theme.palette.secondary.main,
  },

  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

}));

export default useStyles;
